import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {UmpireCompetition} from '@tisa-group/models';

@Injectable()
export class CompetitionService implements CrudService<UmpireCompetition> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireCompetition[]>> {
    return this.http
      .get(`/competitions`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetition>> {
    return this.http
      .get(`/competitions/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  update(
    competition: Partial<UmpireCompetition>,
    prams?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireCompetition>> {
    return this.http
      .patch(`/competitions/${competition.id}`, serialize({stuff: competition}), {
        params: objectToHttpParams(prams),
      })
      .pipe(deserialize());
  }

  delete(competitionId: string): Observable<void> {
    return this.http.delete(`/competitions/${competitionId}`);
  }

  create(
    competition: Partial<UmpireCompetition>,
  ): Observable<JsonApiResponse<UmpireCompetition>> {
    return this.http
      .post('/competitions', serialize({stuff: competition}))
      .pipe(deserialize());
  }
}
